export const isServer = (typeof window === 'undefined') 
    ? true
    : !window?.location?.hrefexport const isServer = (typeof window === 'undefined') 
    ? true
    : !window?.location?.href